import cn from "../../../../utils/cn"

const DataCell = ({ className, children }) => (
  <td
    className={cn(
      "border border-gray-300 px-2 py-2 text-[13.5px] 3xl:text-nowrap text-wrap",
      !children ? "text-center" : "",
      className
    )}
  >
    {children ?? "-"}
  </td>
)

export default DataCell
